(()=>{
 let sequence=0;
 function activate(group,key,focus=false){
  group.querySelectorAll('[data-garmin-tab]').forEach(button=>{
   const active=button.dataset.garminTab===key;
   button.setAttribute('aria-selected',String(active));button.tabIndex=active?0:-1;
   if(active&&focus)button.focus();
  });
  group.querySelectorAll('[data-garmin-panel]').forEach(panel=>{panel.hidden=panel.dataset.garminPanel!==key;});
 }

 function refresh(root){
  const select=root.querySelector('select[name="id"]');
  const sku=select?.selectedOptions[0]?.dataset.sku;
  if(sku)root.querySelectorAll('[data-oh-garmin-sku]').forEach(panel=>{panel.hidden=panel.dataset.ohGarminSku!==sku;});
  const content=root.querySelector('[data-oh-garmin-details]');
  if(!content)return;
  root.classList.add('oh-garmin-controls');
  const disclosure=content.closest('details.oh-product-surface');
  if(disclosure){disclosure.dataset.garminEnhanced='';disclosure.open=true;}
  content.querySelectorAll('[data-garmin-tabs]').forEach(group=>{
   if(!group.dataset.ready){
    group.dataset.ready='true';const prefix='oh-garmin-tabs-'+(++sequence);group.dataset.garminPrefix=prefix;
    const tablist=group.querySelector('.oh-garmin-tabs');tablist.hidden=false;
    // Quick view copies presentation without buttons or IDs. Rebuild only
    // these local navigation controls; native purchase controls stay untouched.
    if(!tablist.querySelector('[data-garmin-tab]')){
     for(const [key,title] of [['overview','Overview'],['specifications','Specifications'],['box','In the Box']]){
      const button=document.createElement('button');button.type='button';button.setAttribute('role','tab');button.dataset.garminTab=key;button.textContent=title;tablist.append(button);
     }
    }
    group.querySelectorAll('[data-garmin-tab]').forEach(button=>{
     const key=button.dataset.garminTab;
     const panel=group.querySelector('[data-garmin-panel="'+key+'"]');
     button.id=prefix+'-'+key;button.setAttribute('aria-controls',prefix+'-panel-'+key);
     panel.id=prefix+'-panel-'+key;panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',button.id);panel.tabIndex=0;
     button.addEventListener('click',()=>{root.dataset.garminActive=key;activate(group,key);});
     button.addEventListener('keydown',event=>{
      if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
      event.preventDefault();const buttons=[...group.querySelectorAll('[data-garmin-tab]')];
      const index=event.key==='Home'?0:event.key==='End'?buttons.length-1:(buttons.indexOf(button)+(event.key==='ArrowRight'?1:-1)+buttons.length)%buttons.length;
      root.dataset.garminActive=buttons[index].dataset.garminTab;activate(group,root.dataset.garminActive,true);
     });
    });
   }
   const prefix=group.dataset.garminPrefix;
   const groupSku=group.closest('[data-oh-garmin-sku]').dataset.ohGarminSku;
   const refs=[...root.querySelectorAll('[data-oh-garmin-sku="'+groupSku+'"] [data-garmin-note-link]')];
   refs.forEach((ref,index)=>{ref.id=prefix+'-ref-'+(index+1);ref.href='#'+prefix+'-note-'+ref.dataset.garminNoteLink;});
   group.querySelectorAll('[data-garmin-note]').forEach(note=>{
    const number=note.dataset.garminNote;note.id=prefix+'-note-'+number;
    const first=refs.find(ref=>ref.dataset.garminNoteLink===number);
    if(first)note.querySelector('[data-garmin-note-back]').href='#'+first.id;
   });
   activate(group,root.dataset.garminActive||'overview');
  });
  if(!root.dataset.garminNotesReady){
   root.dataset.garminNotesReady='true';
   root.addEventListener('click',event=>{
    const ref=event.target.closest('[data-garmin-note-link]');if(!ref)return;
    const refSku=ref.closest('[data-oh-garmin-sku]')?.dataset.ohGarminSku;
    const group=content.querySelector('[data-oh-garmin-sku="'+refSku+'"] [data-garmin-tabs]');
    const note=group?.querySelector('[data-garmin-note="'+ref.dataset.garminNoteLink+'"]');
    if(!note)return;
    event.preventDefault();root.dataset.garminActive='overview';activate(group,'overview');
    note.querySelector('[data-garmin-note-back]').href='#'+ref.id;
    note.tabIndex=-1;note.scrollIntoView({block:'center',behavior:'instant'});note.focus({preventScroll:true});
   });
  }
  const grid=root.querySelector('.oh-shop-product');
  if(disclosure&&grid&&!disclosure.classList.contains('oh-garmin-full-details')){
   disclosure.classList.add('oh-garmin-full-details');grid.after(disclosure);
  }
  const options=[...root.querySelectorAll('.oh-shop-disclosures>details')].find(el=>el.querySelector('summary')?.textContent.trim().startsWith('All Options & Prices'));
  if(options){
   options.classList.add('oh-garmin-options');
   if(grid&&disclosure){const parent=options.parentElement;disclosure.after(options);if(!parent.children.length)parent.hidden=true;}
  }
 }
 function refreshAll(){document.querySelectorAll('[data-native-product],.oh-product-preview,[role="dialog"]').forEach(root=>{if(root.querySelector('[data-oh-garmin-details]'))refresh(root);});}
 document.addEventListener('change',event=>{
  if(event.target.matches('select[name="id"],[data-native-option]'))refreshAll();
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refreshAll);else refreshAll();
 let queued=false;new MutationObserver(records=>{
  if(queued||!records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('[data-oh-garmin-details]')||n.querySelector?.('[data-oh-garmin-details]')))))return;
  queued=true;requestAnimationFrame(()=>{queued=false;refreshAll();});
 }).observe(document.documentElement,{childList:true,subtree:true});
})();
